var _jsxFileName = "/opt/atlassian/pipelines/agent/build/src/components/utility/Banner/index.tsx";
import React from 'react';
import { Text, VStack } from '@adc/parallax-component-library';
import { IconValidationInvalid } from '@adc/parallax-icons';
const Banner = ({
  message,
  submessage,
  testID,
  ...rest
}) => {
  if (!message && !submessage) {
    return null;
  }
  return /*#__PURE__*/React.createElement(VStack, Object.assign({
    background: "$surface.container",
    display: "flex",
    flexDirection: "row",
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: "$neutral.20",
    borderLeftWidth: 0,
    borderRightWidth: 0,
    padding: "$4",
    marginBottom: "$2",
    marginTop: "$3",
    testID: `${testID}-banner-wrapper`
  }, rest, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 18,
      columnNumber: 5
    }
  }), /*#__PURE__*/React.createElement(VStack, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 33,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(IconValidationInvalid, {
    color: "$support.danger.surfaceOnColorAlt",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 34,
      columnNumber: 9
    }
  })), /*#__PURE__*/React.createElement(VStack, {
    marginLeft: "$2",
    display: "flex",
    flex: 1,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 36,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Text, {
    testID: `${testID}-banner-message`,
    color: "$text.100",
    fontSize: "$bodyBase.default",
    fontWeight: "$bodyBase.default",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 37,
      columnNumber: 9
    }
  }, message), /*#__PURE__*/React.createElement(Text, {
    testID: `${testID}-banner-submessage`,
    color: "$text.100",
    fontSize: "$bodyBase.default",
    fontWeight: "$bodyBase.strong",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 45,
      columnNumber: 9
    }
  }, submessage)));
};
export { Banner };